import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLMapElement extends HTMLElement { constructor(tagName: string = 'MAP', ownerDocument?: any) { super(tagName, ownerDocument); } }
